import { render, staticRenderFns } from "./ContactMoneyRecurringCharges.vue?vue&type=template&id=4e642e5a&scoped=true"
import script from "./ContactMoneyRecurringCharges.vue?vue&type=script&lang=js"
export * from "./ContactMoneyRecurringCharges.vue?vue&type=script&lang=js"
import style0 from "./ContactMoneyRecurringCharges.vue?vue&type=style&index=0&id=4e642e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e642e5a",
  null
  
)

export default component.exports